import { createSlice } from "@reduxjs/toolkit";

export let OngoingSessionCount = 0;

const initialState = {
  showDtmf: false,
  connected: false,
  regState: "Unregistered",
  userAgent: {},
  registerer: {},
  outgoingSession: {},
  incomingSession: {},
  sessionId: "",
  sessions: {},
  sessionState: "",
  incomingSessionState: "",
  callDirection: "Outbound",
  connectingStatus: "Failed", //  connecting connected
  toggleTransferCallModal: false,
  blindCallTransfer: false,
  attendentCallTransfer: false,
  noAnswer: false,
  sip_extention: "",
  ConnectingCallModalToggle: false,
  IncomingCallModalToggle: false,
  callTimerDuration: null,
  Session_Count: 0,
  dialNumber: "",
  sipRecentCallUUID: "",
};

const SIPCallsSlice = createSlice({
  name: "SIPCalls",
  initialState,
  reducers: {
    updateSipState: (state, action) => {
      const key = action?.payload?.key;
      const value = action?.payload?.value;
      // @ts-ignore
      state[key] = value;
    },

    closeSelectedCalling: (state) => {
      state.dialNumber = "";
    },

    // /set Register UserAgent Status
    setRegistererState: (state, action) => {
      state.regState = action.payload;
    },

    setRegisterer: (state, action) => {
      state.registerer = action.payload;
    },

    // set sip connected UserAgent
    setUserAgent: (state, action) => {
      state.userAgent = action.payload;
    },

    /// set Sip js Wbsocket Connected Details
    setConnectedInfo: (state, action) => {
      const { connected, connectingStatus } = action.payload;
      state.connected = connected;
      state.connectingStatus = connectingStatus;
    },

    // set sessions
    setCallIncomingOutGoingSession: (state, action) => {
      const { callDirection, session, sessionId } = action.payload;
      if (callDirection === "Inbound") {
        state.incomingSession = session;
      } else {
        state.outgoingSession = session;
      }
      state.callDirection = callDirection;
      state.sessionId = sessionId;
      state.sessions[sessionId] = session;
      state.Session_Count++; // eslint-disable-line  no-plusplus
      OngoingSessionCount++; // eslint-disable-line  no-plusplus
      // Session_Count = 1 + Session_Count;
      // Session_Count++; // eslint-disable-line  no-plusplus
    },

    /// set Ongoing Sessions Status
    setOngoingSessionStatus: (state, action) => {
      state.sessionState = action.payload;
    },

    /// this Function  used For session Remove After Session state Is terminating
    removeSessionData: (state, action) => {
      const removeSessionId = action.payload;

      console.debug("Removing session ID:", removeSessionId);

      // Modify the draft (state) directly by deleting the session
      delete state.sessions[removeSessionId];
    },

    /// this Function  used to reset sipcalls
    clearSIPCalls: (state) => {
      return initialState;
    },
  },
});

export const {
  updateSipState,
  closeSelectedCalling,
  setRegistererState,
  setRegisterer,
  setUserAgent,
  setConnectedInfo,
  setCallIncomingOutGoingSession,
  setOngoingSessionStatus,
  removeSessionData,
  clearSIPCalls,
} = SIPCallsSlice.actions;

export default SIPCallsSlice.reducer;
